import { render, staticRenderFns } from "./ControlProduccion.vue?vue&type=template&id=50fc01d9&"
import script from "./ControlProduccion.vue?vue&type=script&lang=js&"
export * from "./ControlProduccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports